import Container from 'core/display/Container'
import Spine from 'core/display/Spine'
import { signal } from 'services/SignalsService'
import { create } from 'utils/Object'

export default class ChooseSpinePopup extends Container{
  constructor(data) {
    super()
    this._data = data
    this.spine = new Spine(create(data, data.spine))
    this.spine.scale.set(data.scale ? data.scale : 1)
    this.addChild( this.spine)
    this.createSignal()
    if(this.spine.buttons){
      for (let prop in this.spine.buttons) {
        this.spine.buttons[prop].handler = this.createHandlerSignal
      }
    }
  }
  createSignal() {
    signal.on('CHOISE-POPUP-ANIM', this.animate.bind(this))
    signal.on('CHOISE-POPUP-ANIM-PLAY', this.animatePopup.bind(this))
  }

  createHandlerSignal(id){
    signal.dispatch('CHOISE-POPUP-ANIM-PLAY', id)
  }

  async animatePopup(id) {
    const index = id + 1
    const action = game.models.SpinModel.get().action
    this.spine.stop()
    this.spine.setToSetupPose()
    this.spine.setInteractivityChild(false)
    await this.spine.play(`${index}-${action}`, false)
    signal.dispatch('CHOISE-POPUP-ANIM:DONE')
  }

  async animate() {
    this.spine.stop()
    this.spine.setToSetupPose()
    this.spine.setInteractivityChild(this._data.loopAnimation ? false : true)
    await this.spine.play(this._data.animation, false)
    if(this._data.loopAnimation){
      this.spine.setInteractivityChild(true)
      await this.spine.play(this._data.loopAnimation, true)
    }
  }
}
